import { css } from "@linaria/core";
import { units } from "@pm2/compat";

export const button = css`
  position: absolute;
  top: 50%;
  z-index: 2;

  &.prev {
    left: ${units.px(-25)};
  }

  &.next {
    right: ${units.px(-25)};
  }
`;
